import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { Select, message } from 'antd';
import { fetchCountries } from '../../services'; 
import { setSelectedCountry } from '../../redux/slices/locationSlice'
import { selectCombinedShippingLocation } from '../../redux';
import { ICountrySelectorProps } from '../interfaces';
import './selectorCountry.scss';

const { Option } = Select;

const SelectorCountry: React.FC<ICountrySelectorProps> = ({
  onCountryChange,
  selectedCountry: selectedCountryFromProps,
  updateButtonClicked
}) => {
  const dispatch = useAppDispatch();
  const { selectedCountry } = useAppSelector(selectCombinedShippingLocation);
  const { countries, loading } = useAppSelector((state) => state.location);
  const currentSelectedCountry = selectedCountryFromProps ?? selectedCountry ?? '';

  const [localSelectedCountry, setLocalSelectedCountry] = useState<string | null>(null);
  const [errors, setErrors] = useState(false);

  useEffect(() => {
    setLocalSelectedCountry(currentSelectedCountry || null);
    setErrors(false);
  }, [currentSelectedCountry]);

  const handleCountryDropdownVisibleChange = (open: boolean) => {
    if (open && countries.length === 0 && !loading) {
      dispatch(fetchCountries()).catch(() => {
        message.error('Failed to fetch countries.');
      });
    }
  };

  const handleCountryChange = (value: string) => {
    const selected = countries.find((country) => country.name === value);
    if (selected) {
      setLocalSelectedCountry(value);
      onCountryChange(value);
      dispatch(setSelectedCountry(value)); 
      setErrors(false);
    } else {
      setLocalSelectedCountry(null);
      onCountryChange('');
      dispatch(setSelectedCountry(value)); 
      setErrors(true);
    }
  };

  useEffect(() => {
    if (updateButtonClicked) {
      const currentCountry = localSelectedCountry || currentSelectedCountry;
      const hasCountryError = !currentCountry.trim();

      setErrors(hasCountryError);

      if (!hasCountryError) {
        onCountryChange(currentCountry);
      }
      
    }
  }, [updateButtonClicked, localSelectedCountry, currentSelectedCountry, onCountryChange]);

  return (
    <div className="input-container">
        <label className='input-label' htmlFor="shipping-country">Country</label>
        <Select
          id="shipping-country"
          aria-label="Country"
          showSearch
          placeholder="Select Country"
          onChange={handleCountryChange}
          onOpenChange={handleCountryDropdownVisibleChange}
          value={currentSelectedCountry || undefined}
          status={errors ? 'error' : undefined}
          style={{ width: '100%' }}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase()))
          }
        >
          {countries.map((country) => (
            <Option key={country.id} value={country.name}>
              {country.name}
            </Option>
          ))}
        </Select>
    </div>
  );
};

export default SelectorCountry;
